import { render, staticRenderFns } from "./view-policy.vue?vue&type=template&id=c68b1736&scoped=true"
import script from "./view-policy.vue?vue&type=script&lang=js"
export * from "./view-policy.vue?vue&type=script&lang=js"
import style0 from "./view-policy.vue?vue&type=style&index=0&id=c68b1736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68b1736",
  null
  
)

export default component.exports